import { styled } from '@mui/material';

import { useMemo } from 'react';

import { DeferredImage, ErrorMessage, InfoBox, Skeleton } from '@app-velocity/ui';

import { useAppraisalContext } from '../../context/useAppraisalContext';
import { AppraisalPreloader } from './components/AppraisalsPreloader';
import { AppraisalsContent } from './components/AppraisalsContent';
import { PoweredBy } from './components/PoweredBy/PoweredBy';
import { ResultsFooter } from './components/ResultsFooter';

const StyledScreenAppraisals = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  fontSize: 13,
  color: '#6B7181',
  background: '#f0f2f4',
  borderTop: '1px solid #e8e8e8',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  flex: 1,
  overflow: 'auto',
}));

const PagePreviewContainer = styled('div')(({ theme }) => ({
  flex: '0 0 auto',
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background: 'var(--background-background-color)',
  border: '1px solid var(--stroke-stroke-primary-color)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.spacing(49),
  position: 'relative',
  overflow: 'hidden',
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
}));

export const SinglePageReviews = () => {
  const { reviews, category, image, reviewError, status } = useAppraisalContext();

  const poweredBy = useMemo(() => {
    switch (category) {
      case 'ACCESSIBILITY':
        return 'uxcel';
      case 'REFACTORING_UI':
        return 'refactoringui';
    }

    return null;
  }, [category]);

  return (
    <StyledScreenAppraisals>
      {poweredBy ? (
        <PoweredBy by={poweredBy} />
      ) : (
        <Skeleton height={70} variant="light" />
      )}
      {image ? (
        <PagePreviewContainer>
          <DeferredImage src={image} alt="Design" />
        </PagePreviewContainer>
      ) : (
        <Skeleton height={180} variant="light" />
      )}
      {reviewError ? <ErrorMessage error={reviewError} /> : null}
      {status === 'pending' ? <AppraisalPreloader /> : null}
      {!reviewError && reviews && reviews.length > 0 ? (
        <AppraisalsContent />
      ) : null}
      {!reviewError && status !== 'pending' && reviews && reviews.length === 0 ? (
        <InfoBox
          title="appraisals:no_appraisals_generated"
          description="appraisals:no_appraisals_generated_description"
        />
      ) : null}
      <ResultsFooter/>
    </StyledScreenAppraisals>
  );
};
